const contacts = [
    {
        class: 'contact--email',
        iconClass: 'fas fa-envelope',
        desc: 'mutiarabunda@mail.com'
    },
    {
        class: 'contact--whatsapp',
        iconClass: 'fab fa-whatsapp',
        desc: '+6289-333-2222-1111'
    },
    {
        class: 'contact--instagram',
        iconClass: 'fab fa-instagram',
        desc: '@mutiarabundabali'
    },
    {
        class: 'contact--facebook',
        iconClass: 'fab fa-facebook',
        desc: 'Sekolah Karakter Mutiara Bunda Bali'
    },
    {
        class: 'contact--youtube',
        iconClass: 'fab fa-youtube',
        desc: 'Sekolah Karakter Mutiara Bunda Bali'
    }
]


export default contacts